<template><span class="cu">{{ format(shown) }}</span></template>

<script setup>
// Число, которое плавно «досчитывается». Общий компонент. [Claude, 04.11.2026]
import { toRef } from 'vue'
import { useCountUp } from '@/components/process/useCountUp.js'

const props = defineProps({
  value: { type: Number, default: 0 },
  format: { type: Function, default: (v) => Math.round(v).toLocaleString('ru-RU') },
})
const shown = useCountUp(toRef(props, 'value'))
</script>

<style scoped>
.cu { font-variant-numeric: tabular-nums; }
</style>
